
















import {Vue, Component, Prop} from "vue-property-decorator";

@Component({
  name: "BulletPoints",
})
export default class BulletPoints extends Vue {
  @Prop()
  private totalSteps!: number;

  @Prop()
  private activeStep!: number;

  @Prop({ default: true })
  private enablePastClicks!: boolean;

  @Prop({ default: 'intro:step' })
  private goToStepEvent!: string;

  private goToStep(step: number) {
    if (this.enablePastClicks && step < this.activeStep) {
      this.$emit('bulletPoints:goToStep', step);
    }
  }
}
